// removed by extract-text-webpack-plugin
module.exports = {"title":"_1sZAn_tyjriFSqPp2f-TtW","buttonNew":"_26i2M7RvJhbmZtP4WlY5Q2","searchField":"_1d9rkipnbtEv0AEOh-n0Y4","buttonLoadMore":"_3Fr5pZZcQTdSJrmsHfMogP","spinner":"_19xKWD0Y78ihWXLPkx91a0","filters":"_3-YRe3G37v05bnSe6igl7E","filter":"U8P5XGsGD5NgvfHHxK6KJ","label":"FZRWyHKoPUSuZpwXQ_n2Q","item":"_3ctnf4_XDCDe1aBZlgnVOY","table":"_3-OJ3R9KkCA6NclXmanzJX","image":"_1QkrgIV9Afcah-Ynkp2O5I"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Containers/style.scss
// module id = 1253
// module chunks = 0